<div class="mod-QuickQuotes" *ngIf="showQuickQuote">
	<!--<h2 class="mod-QuickQuotes_Title"><strong>Quick Quote</strong></h2>-->
	<component-title [showTitle]=true [showBorders]=true [portletTitle]="header"></component-title>
	<form [formGroup]='quickQuoteForm'>

		<mat-form-field appearance="outline" class="mod-QuickQuotes_Input" id="quick-quote-popup-form">
			<input type="text" [placeholder]="quickQuotePlaceHolder | translate" [attr.aria-label]="'QUICK_QUOTE_ADA_LABEL' | translate" matInput formControlName ="symbolInput" [matAutocomplete]="auto" class="width-90">
			<mat-icon matSuffix><i class="search fa fa-search"></i></mat-icon>
			<mat-autocomplete #auto="matAutocomplete" class="dropdown mod-QuickQuotes_Dropdown" (optionSelected)='showQuoteToolTip($event.option.value)' (closed)='handleClose()' (opened)='handleOpen()' [autoActiveFirstOption]=true>
			<mat-option *ngFor="let symbols of filteredSymbols" [value]="symbols.Symbol">
				<strong class="mod-QuickQuotes_Symbol">{{symbols.Symbol}}</strong>
				<span> {{symbols.Name}}</span>
			</mat-option>
			</mat-autocomplete>
		</mat-form-field>
		<pershing-responsive [respondToWindow]=true [small]="smallRef" [medium]="largeRef" [large]="largeRef"></pershing-responsive>
		<ng-template #smallRef >
		<div *ngIf="showTT && htmlContent && cardDisplay">
			<mat-card class="mod-QuickQuotes_Tooltip smallRef col-xs-12" id="quick-quote-popup">
				<mat-card-header>
					<mat-card-title>
						{{ 'QUICK_QUOTE' | translate}}
					</mat-card-title>
					<button role="button" aria-label="Close" class="close" (click)="clickClose()">
						<i class="fa fa-times-circle-o fa-x" (click)="clickClose()" aria-hidden="true"></i>
					</button>
				</mat-card-header>
				<mat-card-content>
					<hr class="margin-0">
					<div class="row mod-QuickQuotes_TooltipActions no-gutters" role="row">
						<div class="col-xs-6 col-lg-6 mod-QuickQuotes_FullQuoteContainer">
							<span *ngIf="fullQuoteUrl && showFullQuote">
								<a href="javascript:void(0)" (click) = "redirectToFullQuote()" class="mod-QuickQuotes_FullQuoteLink">{{ 'FULL_QUOTE' | translate}}</a>
							</span>
						</div>
						<div class="col-xs-6 col-lg-6 text-right fw-RealTimeQuoteToggle" *ngIf="showRealTimeToggle">
							<mat-form-field appearance="outline">
								<mat-select class="width-90" [(value)]="displayRealtime" (selectionChange)="toggleRealTime()" id="mat-select-display">
									<mat-select-trigger><span *ngIf="!displayRealtime">{{'DELAYED_INACTIVE' | translate}}<sup>†</sup></span></mat-select-trigger>
									<mat-select-trigger><span *ngIf="displayRealtime">{{'REALTIME_INACTIVE' | translate}}</span></mat-select-trigger>
									<mat-option [value]="false">{{'DELAYED_INACTIVE' | translate}}<sup>†</sup></mat-option>
									<mat-option [value]="true">{{'REALTIME_INACTIVE' | translate}}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div class="alert alert-info margin-top-10" role="alert" *ngIf="showLink && !hasAgreed">
							{{ 'EXCHANGE_NAV_TEXT'| translate}}
							<a href="javascript:void(0)" role="link" (click)="redirectToExchangeAgreement()">{{ 'EXCHANGE_NAV_LINK'| translate}}</a>.
					</div>

					<div class="mod-QuickQuotes_TooltipHeader margin-bottom-5">
						<div role="row">
							<strong role="heading" aria-level="1" [attr.aria-label]="htmlContent.Symbol" class="xlarge">{{htmlContent.Symbol}}</strong>
							<span role="heading" aria-level="1" [attr.aria-label]="htmlContent.Name" class="mod-QuickQuotes_CompanyName xsmall strong">{{htmlContent.Name}}</span>

							<span class="right xlarge" role="heading" aria-level="1"><span *ngIf="htmlContent.LastPrice">$</span><strong>{{htmlContent.LastPrice | pershingDecimalFormatingPipe: '1.2-2' }}</strong>
							    <span class="small mod-QuickQuotes_DayChange" [ngClass]="{'positive icon-caret-up': htmlContent.DayChangeValue > 0, 'negative icon-caret-down': htmlContent.DayChangeValue < 0}">
								<span>{{htmlContent.DayChangeValue | pershingDecimalFormatingPipe: '1.2-2' }}</span>
								<span>(</span>{{htmlContent.DayChangePercent | pershingDecimalFormatingPipe: '1.2-2' }}<span>%)</span>
								</span>
								<span class="xsmall" *ngIf="htmlContent.IssueType !== 'MF'"><span *ngIf="htmlContent.LastSaleVolume > 0"> x {{htmlContent.LastSaleVolume}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.LastSaleExchange}}</span></span>
							</span>
						</div>
					</div>

					<dl class="mod-QuickQuotes_Results width-100 margin-0">
						<div class="row padding-0" *ngIf="htmlContent.IssueType !== 'MF'">
							<div class="mod-QuickQuotes_BidSize col-xs-6">
								<dt class=" title">
									{{'BIDSIZE' | translate}}
								</dt>
								<dd class="value">
									<span>$</span>{{htmlContent.Bid | pershingDecimalFormatingPipe: '1.2-2' }}
									<span class="xsmall"><span *ngIf="htmlContent.BidSize > 0"> x {{htmlContent.BidSize}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.BidExchange}}</span></span>
								</dd>
							</div>

							<div class="mod-QuickQuotes_AskSize col-xs-6">
								<dt class="title">
									{{'ASKSIZE' | translate}}
								</dt>
								<dd class="value">
									<span>$</span>{{htmlContent.Ask | pershingDecimalFormatingPipe: '1.2-2' }}
									<span class="xsmall"><span *ngIf="htmlContent.AskSize > 0"> x {{htmlContent.AskSize}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.AskExchange}}</span></span>
								</dd>
							</div>
						</div>
						<div class="row padding-0">
							<div class="mod-QuickQuotes_Volume col-xs-6" *ngIf="htmlContent.IssueType !== 'MF'">
								<dt class="title">
									{{'VOLUME' | translate}}
								</dt>
								<dd class="value">
									{{htmlContent.Volume | pershingDecimalFormatingPipe: '1.0-0'}}
								</dd>
							</div>
							<div class="mod-QuickQuotes_Open col-xs-6">
									<dt class="title">
										{{'OPENCLOSE' | translate}}
									</dt>
									<dd class="value">
										<span>$</span>{{htmlContent.Open | pershingDecimalFormatingPipe: '1.2-2' }} / <span>$</span>{{htmlContent.Close | pershingDecimalFormatingPipe: '1.2-2' }}
									</dd>
								</div>
						</div>
						<div class="row padding-0" *ngIf="htmlContent.IssueType === 'MF'">
							<div class="mod-QuickQuotes_Nav col-xs-6">
								<dt class="title">
									{{'NAV' | translate}}
								</dt>
								<dd class="value">
									{{htmlContent.NAV}}
								</dd>
							</div>
							<div class="mod-QuickQuotes_Pop col-xs-6">
								<dt class="title">
									{{'POP' | translate}}
								</dt>
								<dd class="value">
									{{htmlContent.POP}}
								</dd>
							</div>
						</div>
						<div class="row padding-top-10">
							<div class="mod-QuickQuotes_52WeekHigh col-xs-6">
								<dt class="title">
									{{'52WEEKHIGHLOW' | translate}}
								</dt>
								<dd class="value">
									<span>$</span>{{htmlContent._52WeekHigh | pershingDecimalFormatingPipe: '1.2-2' }} / <span>$</span>{{htmlContent._52WeekLow | pershingDecimalFormatingPipe: '1.2-2' }}
								</dd>
							</div>
						</div>
					</dl>

					<div class="mod-QuickQuotes_TooltipDisclosures padding-top-15 padding-bottom-20">
						<p class="muted padding-left-5 padding-top-5 margin-bottom-0" role="presentation"> {{'QUOTEASOF' | translate}}
							{{htmlContent.LastPriceTime}}
							<br/>
						<span class="muted padding-top-0" *ngIf="!isRealTimePref" role="presentation"> <sup>†</sup> {{'QUOTEDATAAGREEMENT' | translate}}</span>
					</p>
					</div>

					<img class="mod-QuickQuotes_Chart" [src]="htmlContent.ChartURL" alt="Chart unavailable">
				</mat-card-content>
			</mat-card>
		</div>
		</ng-template>
		<ng-template #largeRef >
			<div *ngIf="showTT && htmlContent && cardDisplay">
				<mat-card class="mod-QuickQuotes_Tooltip mediumRef" id="quick-quote-popup">
					<mat-card-header *ngIf="deviceType === 'mobile'">
						<mat-card-title>
							{{ 'QUICK_QUOTE' | translate}}
						</mat-card-title>
						<button role="button" aria-label="Close" class="close" (click)="clickClose()">
							<i class="fa fa-times-circle-o fa-x" (click)="clickClose()" aria-hidden="true"></i>
						</button>
					</mat-card-header>
					<mat-card-content>
						<div class="row mod-QuickQuotes_TooltipActions no-gutters" role="row">
							<div class="col-xs-6 col-lg-6 mod-QuickQuotes_FullQuoteContainer">
								<span *ngIf="fullQuoteUrl && showFullQuote">
									<a href="javascript:void(0)" (click) = "redirectToFullQuote()" class="mod-QuickQuotes_FullQuoteLink">{{ 'FULL_QUOTE' | translate}}</a>
								</span>
							</div>
							<div class="col-xs-6 col-lg-6 text-right fw-RealTimeQuoteToggle" *ngIf="showRealTimeToggle">
								<div class="fw-RealTimeQuoteToggle_ButtonGroup" [hidden]="isRealTimePref">
									<button class="text-link fw-RealTimeQuoteToggle_Button fw-RealTimeQuoteToggle_Button-inactive fw-RealTimeQuoteToggle_Button-realTime fw-RealTimeQuoteToggle_Button-realTimeInactive"
											mat-button [innerHTML] = " 'REALTIME_INACTIVE' | translate"
											(click) = "toggleRealTime()">
									</button>
									<span class="realTimeToggleVerticalBar">|</span>
									<button class="text-link fw-RealTimeQuoteToggle_Button fw-RealTimeQuoteToggle_Button-active fw-RealTimeQuoteToggle_Button-delayed fw-RealTimeQuoteToggle_Button-delayedActive"
											mat-button [innerHTML] = " 'DELAYED_ACTIVE' | translate"
											(click) = "toggleRealTime()">
									</button>
								</div>
								<div class="btn-group" [hidden]="!isRealTimePref">
									<button class="text-link fw-RealTimeQuoteToggle_Button fw-RealTimeQuoteToggle_Button-active fw-RealTimeQuoteToggle_Button-realTime fw-RealTimeQuoteToggle_Button-realTimeActive"
										mat-button [innerHTML] = " 'REALTIME_ACTIVE' | translate"
										(click) = "toggleRealTime()">
									</button>
									<span class="realTimeToggleVerticalBar">|</span>
									<button class="text-link fw-RealTimeQuoteToggle_Button fw-RealTimeQuoteToggle_Button-active fw-RealTimeQuoteToggle_Button-delayed fw-RealTimeQuoteToggle_Button-delayedActive"
										mat-button [innerHTML] = " 'DELAYED_INACTIVE' | translate"
										(click) = "toggleRealTime()">
									</button>
								</div>
							</div>
						</div>
						<div class="alert alert-info" role="alert" *ngIf="showLink && !hasAgreed">
								{{ 'EXCHANGE_NAV_TEXT'| translate}}
								<a href="javascript:void(0)" role="link" (click)="redirectToExchangeAgreement()">{{ 'EXCHANGE_NAV_LINK'| translate}}</a>.
						</div>

						<div class="mod-QuickQuotes_TooltipHeader margin-bottom-5">
							<div role="row">
								<strong role="heading" aria-level="1" [attr.aria-label]="htmlContent.Symbol" class="xlarge">{{htmlContent.Symbol}}</strong>
								<strong role="heading" aria-level="1" [attr.aria-label]="htmlContent.Name" class="mod-QuickQuotes_CompanyName xsmall">{{htmlContent.Name}}</strong>

								<span class="right xlarge" role="heading" aria-level="1"><span *ngIf="htmlContent.LastPrice">$</span><strong>{{htmlContent.LastPrice | pershingDecimalFormatingPipe: '1.2-2' }}</strong>
									<span class="small mod-QuickQuotes_DayChange" [ngClass]="{'positive icon-caret-up': htmlContent.DayChangeValue > 0, 'negative icon-caret-down': htmlContent.DayChangeValue < 0}">
									<span>{{htmlContent.DayChangeValue | pershingDecimalFormatingPipe: '1.2-2' }}</span>
									<span>(</span>{{htmlContent.DayChangePercent | pershingDecimalFormatingPipe: '1.2-2' }}<span>%)</span>
									</span>
									<span class="xsmall" *ngIf="htmlContent.IssueType !== 'MF'"><span *ngIf="htmlContent.LastSaleVolume > 0"> x {{htmlContent.LastSaleVolume}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.LastSaleExchange}}</span></span>
								</span>
							</div>
						</div>

						<dl class="mod-QuickQuotes_Results width-100 margin-0">
							<div class="row padding-0" *ngIf="htmlContent.IssueType !== 'MF'">
								<div class="mod-QuickQuotes_BidSize col-sm-4 col-xs-4">
									<dt class=" title">
										{{'BIDSIZE' | translate}}
									</dt>
									<dd class="value">
										<span>$</span>{{htmlContent.Bid | pershingDecimalFormatingPipe: '1.2-2' }}
										<span class="xsmall"><span *ngIf="htmlContent.BidSize > 0"> x {{htmlContent.BidSize}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.BidExchange}}</span></span>
									</dd>
								</div>

								<div class="mod-QuickQuotes_AskSize col-sm-4 col-xs-4">
									<dt class="title">
										{{'ASKSIZE' | translate}}
									</dt>
									<dd class="value">
										<span>$</span>{{htmlContent.Ask | pershingDecimalFormatingPipe: '1.2-2' }}
										<span class="xsmall"><span *ngIf="htmlContent.AskSize > 0"> x {{htmlContent.AskSize}}</span><span class="margin-left-5 mod-QuickQuotes_Exchange">{{htmlContent.AskExchange}}</span></span>
									</dd>
								</div>

								<div class="mod-QuickQuotes_Volume col-sm-4 col-xs-4">
									<dt class="title">
										{{'VOLUME' | translate}}
									</dt>
									<dd class="value">
										{{htmlContent.Volume | pershingDecimalFormatingPipe: '1.0-0' }}
									</dd>
								</div>
							</div>
							<div class="row padding-0" *ngIf="htmlContent.IssueType === 'MF'">
								<div class="mod-QuickQuotes_Nav col-sm-4 col-xs-4">
									<dt class="title">
										{{'NAV' | translate}}
									</dt>
									<dd class="value">
										{{htmlContent.NAV}}
									</dd>
								</div>
								<div class="mod-QuickQuotes_Pop col-sm-4 col-xs-4">
									<dt class="title">
										{{'POP' | translate}}
									</dt>
									<dd class="value">
										{{htmlContent.POP}}
									</dd>
								</div>
							</div>
							<div class="row padding-top-10">
								<div class="mod-QuickQuotes_Open col-sm-5 col-xs-5">
									<dt class="title">
										{{'OPENCLOSE' | translate}}
									</dt>
									<dd class="value">
										<span>$</span>{{htmlContent.Open | pershingDecimalFormatingPipe: '1.2-2' }} / <span>$</span>{{htmlContent.Close | pershingDecimalFormatingPipe: '1.2-2' }}
									</dd>
								</div>
								<div class="mod-QuickQuotes_52WeekHigh col-sm-5 col-xs-5">
									<dt class="title">
										{{'52WEEKHIGHLOW' | translate}}
									</dt>
									<dd class="value">
										<span>$</span>{{htmlContent._52WeekHigh | pershingDecimalFormatingPipe: '1.2-2' }} / <span>$</span>{{htmlContent._52WeekLow | pershingDecimalFormatingPipe: '1.2-2' }}
									</dd>
								</div>
							</div>
						</dl>

						<div class="mod-QuickQuotes_TooltipDisclosures padding-top-15 padding-bottom-20">
							<p class="muted padding-left-5 padding-top-5 margin-bottom-0" role="presentation"> {{'QUOTEASOF' | translate}}
								{{htmlContent.LastPriceTime}}
								<br/>
							<span class="muted padding-top-0" *ngIf="!isRealTimePref" role="presentation"> <sup>†</sup> {{'QUOTEDATAAGREEMENT' | translate}}</span>
						</p>
						</div>

						<img class="mod-QuickQuotes_Chart" [src]="htmlContent.ChartURL" alt="Chart unavailable">
					</mat-card-content>
				</mat-card>
			</div>
			</ng-template>
	</form>
</div>
